var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-type-badge"},[_vm._v(" "+_vm._s(_vm.$t(`global.serviceSequence`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }